import { AccessGroup } from "./accessGroup";
import { randomColor } from "../helpers/color";

export default class Population extends AccessGroup {
	constructor({
		id,
		name,
		icon,
		icon_color,
		rules,
		stats = null,
		accessGroupRightCount = null,
		periods = null,
		zones = null
	} = {}) {
		super({ id, name, rules, accessGroupRightCount, stats });
		this.icon = icon || "group";
		this.icon_color = icon_color || randomColor();
		this.periods = periods || [];
		this.zones = zones || [];
	}

	static buildFromJSON(json) {
		return new Population({
			...super.buildFromJSON(json),
			icon: json.icon,
			icon_color: json.icon_color,
			periods: json.periods ?? null,
			zones: json.zones ?? null
		});
	}

	toJSON() {
		return {
			...super.toJSON(),
			icon: this.icon,
			icon_color: this.icon_color
		};
	}

	getId() {
		return this.id;
	}

	getName() {
		return this.name;
	}

	getIcon() {
		return this.icon;
	}

	getIconColor() {
		return this.icon_color;
	}
	getAccessGroupRightCount() {
		return this.accessGroupRightCount;
	}
}
